<template>
    <div class="loading">
      <!-- 这里可以放置你的加载动画元素 -->
      <div class="spinner"></div>
    </div>
  </template>
  
  <style>
  .loading {
    /* 设置加载动画的容器样式 */
    display: flex;
    justify-content: center;
    align-items: center;
    height: 690px; /* 根据你的需求设置高度 */
  }
  
  .spinner {
    /* 设置加载动画的样式 */
    background-image: url('../images/mail.gif') !important;
	background-repeat: no-repeat;
	background-size: 280px 200px;
	height: 100px;
	width: 100%;
	background-position: center;
  }
  
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  </style>
  